export const extractSizeGuideId = (sizeGuideUrl) => {
  if (!sizeGuideUrl) return null;

  const newFormatMatch = sizeGuideUrl.match(/SizeGuide\/(\d+)/);
  if (newFormatMatch) {
    return parseInt(newFormatMatch[1], 10);
  }

  const legacyFormatMatch = sizeGuideUrl.match(/productType=(\d+)/);
  if (legacyFormatMatch) {
    return parseInt(legacyFormatMatch[1], 10);
  }

  return null;
};
